import React from 'react'

const Dashboard = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height:'100vh' }}>
            <h1>Dashboard</h1>
        </div>
    )
}

export default Dashboard
